import React from "react";
import { ReactComponent as MirrorSvg } from "../svg/mirror.svg";

export default function MirrorIcon({ size = 64, color = "#32363F", ...props }) {
  return <MirrorSvg width={size} height={size} style={{ color }} {...props} />;
}
